import {MainRequest} from 'Services/common';
import {Key} from 'react';

const UrlMap = {
    list: '/aichat/agent/mcp',
    options: '/aichat/agent/mcp/not',
    edit: '/aichat/agent/mcp/saves',
    remove: '/aichat/agent/mcp/deletes',
};
export class AgentMcp {
    static list(params: AgentMcp.QueryList) {
        return MainRequest.get<SuccessData<AgentMcp.List[]>>(
            `${UrlMap.list}/${params?.agentId}`,
            {
                params,
            },
        ).then(res => res.data.data);
    }
    static options(params: AgentMcp.QueryList) {
        return MainRequest.get<SuccessData<AgentMcp.List[]>>(
            `${UrlMap.options}/${params?.agentId}`,
            {
                params,
            },
        ).then(res => res.data.data);
    }

    static async save({agentId, data}: AgentMcp.Save) {
        return MainRequest.post(`${UrlMap.edit}/${agentId}`, data);
    }

    static async remove({agentId, ids}: AgentMcp.Remove) {
        return MainRequest.post(`${UrlMap.remove}/${agentId}`, ids);
    }
}

export namespace AgentMcp {
    export type QueryForm = {};

    export interface Schema {
        code: string; //MCP Server编码，唯一标识
        name: string; //Server名称
        description: string; //Server描述
        baseUrl: string; //基础URL
        status: boolean; //状态：0-禁用，1-启用
        priority: number; //优先级
        enabled: boolean; //是否启用
    }

    export interface List extends Schema {
        id: string;
        updatedAt: string;
        createdAt: string;
    }

    export interface Form extends Schema {
        id?: string;
    }

    export interface Save {
        agentId: string;
        data: Form[];
    }

    export interface Remove {
        agentId: string;
        ids: Key[];
    }

    export type QueryList = QueryForm & {agentId: string};
}
